import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon GroupIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const GroupIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 16 16">
      <circle cx={8} cy={8} r={8} fill="#00AA66" />
      <path
        d="M7.18066 8.46085C7.18066 7.62654 7.85701 6.9502 8.69132 6.9502H11.0605C11.8948 6.9502 12.5711 7.62654 12.5711 8.46085C12.5711 9.29517 11.8948 9.97151 11.0605 9.97151H10.1146"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M9.09717 8.50723C8.96434 9.37082 8.21036 10.0011 7.3369 9.9787L4.91868 9.91667C4.08922 9.8954 3.42788 9.21688 3.42788 8.38714C3.42788 7.54213 4.11289 6.85712 4.9579 6.85711L5.71436 6.8571"
        stroke="white"
        strokeLinecap="round"
      />
    </Icon>
  )
}
export default GroupIcon
